(function () {
  'use strict';

  function findSubmitControl(root) {
    if (root.dataset.vatpanCustomOrderPolicyContext === 'configurator') {
      var cfgRoot = root.closest('[data-vatpan-rack-configurator]');
      if (!cfgRoot || !cfgRoot.dataset.cfgId) return null;
      return document.getElementById(cfgRoot.dataset.cfgId + '-submit-btn');
    }

    var form = root.closest('form');
    if (!form) return null;
    return form.querySelector('[type="submit"], button:not([type])');
  }

  function setSubmitEnabled(submitControl, enabled) {
    if (!submitControl) return;
    submitControl.disabled = !enabled;
  }

  function showError(root, show) {
    var error = root.querySelector('[data-vatpan-custom-order-policy-error]');
    if (!error) return;
    if (show) error.removeAttribute('hidden');
    else error.setAttribute('hidden', '');
  }

  function initPolicy(root) {
    if (root.dataset.vatpanCustomOrderPolicyInit === 'true') return;
    root.dataset.vatpanCustomOrderPolicyInit = 'true';

    var checkbox = root.querySelector('[data-vatpan-custom-order-policy-accept]');
    if (!checkbox) return;

    var submitControl = findSubmitControl(root);
    setSubmitEnabled(submitControl, checkbox.checked);

    checkbox.addEventListener('change', function () {
      setSubmitEnabled(submitControl, checkbox.checked);
      if (checkbox.checked) showError(root, false);
    });

    var form = root.closest('form');
    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          if (checkbox.checked) return;
          event.preventDefault();
          showError(root, true);
          checkbox.focus();
        },
        true
      );
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vatpan-custom-order-policy]').forEach(initPolicy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.vatpanValidateCustomOrderPolicy = function (root) {
    if (!root) return true;
    var checkbox = root.querySelector('[data-vatpan-custom-order-policy-accept]');
    if (!checkbox) return true;
    if (checkbox.checked) {
      showError(root, false);
      return true;
    }
    showError(root, true);
    checkbox.focus();
    return false;
  };
})();
